import { DiamondPlus, Funnel, OctagonMinus } from 'lucide-react';
import { Button } from 'primereact/button';
import { Panel } from 'primereact/panel';

import FilterSection from './FilterSection';

const FilterPanel = ({
  selectedTable,
  selectedChartTable,
  action,
  showChartFilter,
  setShowChartFilter,
  copyFilter,
  widgetFormik,
  dimensionList,
  isCopyUse,
  isWarrantyEnabled,
}) => {
  const headerTemplate = () => {
    return (
      <div className="flex align-items-center gap-2 text-sm font-medium text-gray-700">
        <div className="col align-items-center justify-content-start gap-2 flex">
          <Funnel className="text-primary text-sm w-1rem h-1rem" />

          <span className="text-sm font-bold text-gray-500">
            Chart Filters <span className="text-red-400">*</span>
          </span>
          {selectedTable == selectedChartTable && (
            <Button
              size="small"
              onClick={() => copyFilter()}
              label="Copy from Report"
              outlined
            ></Button>
          )}
        </div>
      </div>
    );
  };

  return (
    <Panel header={headerTemplate} className="w-full">
      <div className="grid grid-nogutter gap-2">
        {action !== 'view' && (
          <>
            {showChartFilter ? (
              <Button
                disabled={
                  widgetFormik.values.chart_filter_conditions?.filters?.[0]
                    ?.fields?.[0]?.tableField && showChartFilter
                }
                icon={<OctagonMinus className="text-sm w-1rem h-1rem" />}
                pt={{ label: { className: 'pl-1 text-xs' } }}
                label="Remove Filter Condition"
                className={`border-round-md py-2`}
                onClick={() => {
                  if (
                    !(
                      widgetFormik.values.chart_filter_conditions?.filters?.[0]
                        ?.fields?.[0]?.tableField && showChartFilter
                    )
                  ) {
                    setShowChartFilter(false);
                  }
                }}
              />
            ) : (
              <Button
                icon={<DiamondPlus className="text-sm w-1rem h-1rem" />}
                label="Add New Filter Condition"
                pt={{ label: { className: 'pl-1 text-xs' } }}
                className={`border-round-md py-2`}
                onClick={() => {
                  widgetFormik.setFieldValue('chart_filter_conditions', {
                    condition: 'and',
                    filters: [
                      {
                        condition: 'and',
                        fields: [{ tableField: '', operator: '', value: '' }],
                      },
                    ],
                  });
                  setShowChartFilter(true);
                }}
              />
            )}
          </>
        )}
        {showChartFilter && (
          <FilterSection
            action={action}
            widgetFormik={widgetFormik}
            filterConditions={widgetFormik.values.chart_filter_conditions}
            dimensionList={dimensionList?.filter(item => {
              let flag = true;
              if (item?.meta?.tenantPermission) {
                flag = isWarrantyEnabled();
              }
              return (
                item?.firstLetter == selectedChartTable &&
                !item?.meta?.hideInFilter &&
                flag
              );
            })}
            filterFor="chart_filter_conditions"
            isCopyUse={isCopyUse}
          />
        )}
      </div>
    </Panel>
  );
};

export default FilterPanel;
